/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_Notify_HintInputs */



/**
* | output |
* | --- |
* | "Same as acting on its own for now." |
*
* @param {Agent_Builder_Confirmation_Notify_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_notify_hint = /** @type {((inputs?: Agent_Builder_Confirmation_Notify_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_Notify_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Derzeit wie selbstständig.")
	return /** @type {LocalizedString} */ ("Same as acting on its own for now.")
});